import _              from 'underscore';
import { trimString } from '../FormattingUtility';

export function sum( items: number[], startingSum: number = 0, debug = false ): number{
	
	let sum = _.reduce( items, ( sum, n ) => sum + n, startingSum );
	
	if( debug ){
		console.log( `${ _.compact( items ).join( ' + ' ) } = ${ sum }` )
	}
	
	return sum;
}

export function sumByAttribute<D>( items: D[], attributeOrIndexPath: string | string[] | number[], startingSum: number = 0 ): number{
	return _.reduce( items, ( sum, item ) => ( sum + parseFloat( trimString( `${ _.property( attributeOrIndexPath )( item ) ?? 0 }` ) ) ), startingSum );
}

export function applyPercentageToValue( value: number = 0, percentage: number = 0 ): number{
	return value + ( value * percentage );
}

export function percentage( num: number, denom: number, mathFunction: 'floor' | 'ceil' = null ){
	return ( denom > 0 )
	       ? mathFunction
	         ? Math[ mathFunction ]( ( num / denom ) * 100 )
	         : ( num / denom ) * 100
	       : 0;
}

export function decimalOf( num: number, precision: number = null ){
	
	let decimals = num - Math.floor( num );
	
	let parts         = num.toString().split( '.' ),
	    decimalPlaces = ( parts.length > 1 ) ? parts[ 1 ].length : 0;
	
	return decimals.toFixed( precision ?? decimalPlaces );
}

export function getArrColumnTotals( data: number[][] ){
	
	let rowCount = 0;
	
	if( data.length ){
		
		rowCount = data[ 0 ].length;
		
		return _.range( 0, rowCount )
		        .map( n => data.map( ds => ds[ n ] ) )
		        .map( ( totals: number[] ) => sum( totals ) );
	}
	
	return []
}
